// Textes de la page des utilisateurs
export const USERS_TEXTS = {
  title: 'Utilisateurs',
  addUser: 'Ajouter un utilisateur',
  updateUser: 'Modifier l\'utilisateur',
  email: 'Email',
  name: 'Nom',
  organization: 'Organisation',
  role: 'Rôle',
  loading: 'Chargement des utilisateurs...',
  errorLoading: 'Erreur lors du chargement des utilisateurs',
  noUsers: 'Aucun utilisateur trouvé',
  rowsPerPage: 'Lignes par page :',
  locations: 'Locations accessibles',
  errors: {
    USER_EMAIL_REQUIRED: 'L\'email est requis',
    USER_NAME_REQUIRED: 'Le nom est requis',
    USER_ORGANIZATION_REQUIRED: 'L\'organisation est requise',
    USER_ID_REQUIRED: 'L\'ID utilisateur est requis',
    USER_EMAIL_EMPTY: 'L\'email ne peut pas être vide',
    USER_NAME_EMPTY: 'Le nom ne peut pas être vide',
    USER_ORGANIZATION_EMPTY: 'L\'organisation ne peut pas être vide',
    EMAIL_FORMAT_INVALID: 'Format d\'adresse email invalide',
    USER_ROLE_INVALID: 'Rôle d\'utilisateur invalide',
    USER_LOCATION_IDS_REQUIRED: 'Au moins une location doit être sélectionnée pour un utilisateur de type locations',
    CREATE_USER_FAILED: 'Échec de la création de l\'utilisateur',
    UPDATE_USER_FAILED: 'Échec de la modification de l\'utilisateur'
  },
  // Textes du dialogue de document JSON de l'utilisateur
  documentDialog: {
    title: 'Document JSON de l\'utilisateur',
    userLabel: 'Utilisateur :',
    description: 'Visualisation du document complet de l\'utilisateur en format JSON'
  }
} as const;